// extracted by mini-css-extract-plugin
export default {"primaryBtn":"Buttons_primaryBtn__q-TJH","defaultBtn":"Buttons_defaultBtn__QSO6W"};